import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

/**
 * Archived/Active selector shared by the models and processing site pages'
 * right controls.
 */
@Component({
  selector: 'app-archive-mode-select',
  templateUrl: './archive-mode-select.component.html',
  styleUrls: ['./archive-mode-select.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class ArchiveModeSelectComponent {
  @Input() showArchived = false;
  @Output() archiveChange = new EventEmitter<boolean>();
}
